import { Protocolo } from "../domain/entities/protocolo";
import { ProtocoloService } from "../domain/services/protocoloService";

export class GetProtocolos {
  constructor(private protocoloService: ProtocoloService) {}

  async execute(
    startDate: string,
    endDate: string,
    token: string
  ): Promise<Protocolo[]> {
    //console.log("GetProtocolos:", startDate, endDate, token);
    return await this.protocoloService.getProtocolos(startDate, endDate, token);
  }
}
